{
  "header": {
    "nav": {
      "solutions": "Solutions",
      "developers": "Developers",
      "contact": "Contact"
    },
    "signIn": "Sign In",
    "getStarted": "Get Started",
    "goToDashboard": "Go to Dashboard",
    "openMenu": "Open main menu"
  },
  "hero": {
    "title": "Manage Your Service Business",
    "titleHighlight": "Effortlessly",
    "subtitle": "The all-in-one platform to schedule appointments, manage customers, track revenue, and grow your service business. Start free, scale easily.",
    "startTrial": "Start Free Trial",
    "seeHowItWorks": "See How It Works"
  },
  "features": {
    "title": "Everything You Need to Succeed",
    "subtitle": "Powerful features designed to help you save time, increase revenue, and deliver exceptional customer experiences.",
    "items": {
      "scheduling": {
        "name": "Smart Scheduling",
        "description": "Intelligent appointment scheduling that reduces no-shows and maximizes your calendar efficiency."
      },
      "customers": {
        "name": "Customer Management",
        "description": "Keep track of customer history, preferences, and interactions in one centralized place."
      },
      "analytics": {
        "name": "Analytics Dashboard",
        "description": "Get insights into your business performance with real-time analytics and reporting."
      },
      "payments": {
        "name": "Payment Processing",
        "description": "Accept payments seamlessly with integrated payment processing and invoicing."
      },
      "reminders": {
        "name": "Automated Reminders",
        "description": "Reduce no-shows with automated email and SMS reminders for appointments."
      },
      "security": {
        "name": "Secure & Reliable",
        "description": "Enterprise-grade security with 99.9% uptime guarantee for your peace of mind."
      },
      "mobile": {
        "name": "Mobile Ready",
        "description": "Manage your business on the go with our fully responsive mobile experience."
      },
      "booking": {
        "name": "Online Booking",
        "description": "Let customers book appointments online 24/7 through your personalized booking page."
      }
    }
  },
  "testimonials": {
    "title": "Loved by Businesses Everywhere",
    "subtitle": "See what our customers have to say about their experience with Woezor.",
    "items": {
      "sarah": {
        "content": "Woezor has transformed how we manage appointments. Our no-show rate dropped by 60% in the first month!",
        "role": "Owner, Serenity Spa"
      },
      "michael": {
        "content": "The analytics dashboard gives me insights I never had before. I can finally make data-driven decisions for my clinic.",
        "role": "Director, Family Health Clinic"
      },
      "emily": {
        "content": "Setting up was incredibly easy. Within a day, we had online booking running and customers were already scheduling.",
        "role": "Manager, Elite Fitness Studio"
      },
      "james": {
        "content": "The customer support is exceptional. They helped us customize everything to fit our unique workflow.",
        "role": "Founder, Wilson Consulting"
      },
      "lisa": {
        "content": "We've increased our bookings by 40% since switching to Woezor. The ROI has been incredible.",
        "role": "Owner, Park Beauty Lounge"
      },
      "david": {
        "content": "Finally, a scheduling system that actually works for service businesses. Highly recommend!",
        "role": "CEO, Thompson Home Services"
      }
    }
  },
  "cta": {
    "title": "Ready to Transform Your Business?",
    "subtitle": "Join thousands of service businesses that trust Woezor to manage their appointments, customers, and growth. Start your free trial today.",
    "getStarted": "Get Started Free",
    "talkToSales": "Talk to Sales",
    "benefits": {
      "trial": "14-day free trial",
      "noCard": "No credit card required",
      "cancel": "Cancel anytime"
    }
  },
  "footer": {
    "company": "Company",
    "product": "Product",
    "legal": "Legal",
    "connect": "Connect",
    "about": "About",
    "contact": "Contact",
    "features": "Features",
    "pricing": "Pricing",
    "privacy": "Privacy Policy",
    "terms": "Terms of Service",
    "twitter": "Twitter",
    "linkedin": "LinkedIn",
    "copyright": "© {{year}} ForumOne. All rights reserved."
  },
  "solutions": {
    "heroTitle": "Solutions for Every Business",
    "heroSubtitle": "Discover how Woezor can transform your service business with powerful tools designed to save time, increase revenue, and delight your customers.",
    "items": {
      "appointments": {
        "title": "Appointment Management",
        "description": "Streamline your booking process with our intelligent scheduling system. Reduce no-shows and maximize your calendar efficiency.",
        "features": {
          "portal": "Online booking portal",
          "reminders": "Automated reminders",
          "sync": "Calendar sync",
          "recurring": "Recurring appointments"
        }
      },
      "customers": {
        "title": "Customer Management",
        "description": "Build stronger relationships with your customers. Track interactions, preferences, and history all in one place.",
        "features": {
          "profiles": "Customer profiles",
          "history": "Interaction history",
          "notes": "Notes and tags",
          "segmentation": "Segmentation"
        }
      },
      "analytics": {
        "title": "Analytics & Insights",
        "description": "Make data-driven decisions with comprehensive analytics. Understand your business performance at a glance.",
        "features": {
          "revenue": "Revenue tracking",
          "trends": "Booking trends",
          "insights": "Customer insights",
          "reports": "Custom reports"
        }
      },
      "payments": {
        "title": "Payment Processing",
        "description": "Accept payments seamlessly. Multiple payment methods, automatic invoicing, and financial tracking.",
        "features": {
          "methods": "Multiple payment methods",
          "invoicing": "Automatic invoicing",
          "reminders": "Payment reminders",
          "reports": "Financial reports"
        }
      },
      "notifications": {
        "title": "Notifications & Alerts",
        "description": "Keep everyone informed. Automated notifications for appointments, updates, and important events.",
        "features": {
          "email": "Email notifications",
          "sms": "SMS reminders",
          "push": "Push notifications",
          "triggers": "Custom triggers"
        }
      },
      "security": {
        "title": "Security & Compliance",
        "description": "Your data is safe with us. Enterprise-grade security and compliance with industry standards.",
        "features": {
          "encryption": "Data encryption",
          "access": "Role-based access",
          "audit": "Audit logs",
          "gdpr": "GDPR compliant"
        }
      }
    },
    "industriesTitle": "Built for Your Industry",
    "industriesSubtitle": "Whether you're a solo practitioner or managing multiple locations, Woezor adapts to your specific needs.",
    "industries": {
      "healthcare": {
        "title": "Healthcare",
        "description": "Medical practices, clinics, and healthcare providers"
      },
      "beauty": {
        "title": "Beauty & Wellness",
        "description": "Salons, spas, and wellness centers"
      },
      "professional": {
        "title": "Professional Services",
        "description": "Consultants, lawyers, and accountants"
      },
      "fitness": {
        "title": "Fitness",
        "description": "Gyms, personal trainers, and fitness studios"
      },
      "education": {
        "title": "Education",
        "description": "Tutors, coaches, and training centers"
      },
      "home": {
        "title": "Home Services",
        "description": "Cleaning, repairs, and maintenance"
      }
    },
    "ctaTitle": "Ready to Transform Your Business?",
    "ctaSubtitle": "Join thousands of businesses already using our platform to grow.",
    "startTrial": "Start Free Trial",
    "contactSales": "Contact Sales"
  },
  "contact": {
    "heroTitle": "Get in Touch",
    "heroSubtitle": "Have questions about Woezor? Want to see a demo? Our team is here to help you find the perfect solution for your business.",
    "formTitle": "Send us a message",
    "formDescription": "Fill out the form below and we'll get back to you as soon as possible.",
    "name": "Name",
    "email": "Email",
    "company": "Company",
    "message": "Message",
    "namePlaceholder": "Your name",
    "emailPlaceholder": "you@example.com",
    "companyPlaceholder": "Your company (optional)",
    "messagePlaceholder": "How can we help you?",
    "send": "Send Message",
    "sending": "Sending...",
    "success": "Message sent! We'll get back to you soon.",
    "errors": {
      "nameRequired": "Name is required",
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email",
      "messageRequired": "Message is required"
    },
    "infoTitle": "Contact Information",
    "infoSubtitle": "Reach out to us through any of these channels.",
    "channels": {
      "email": {
        "title": "Email",
        "description": "Our team will respond within 24 hours"
      },
      "phone": {
        "title": "Phone",
        "description": "Mon-Fri from 8am to 6pm"
      },
      "office": {
        "title": "Office",
        "description": "Come visit us"
      },
      "hours": {
        "title": "Hours",
        "description": "Working hours",
        "value": "Mon - Fri: 8am - 6pm"
      }
    },
    "faqTitle": "Frequently Asked Questions",
    "faqDescription": "Looking for quick answers? Check out our FAQ section for common questions about pricing, features, and getting started.",
    "viewFaq": "View FAQ →"
  },
  "developers": {
    "badge": "Developer Platform",
    "heroTitle": "Build with Woezor API",
    "heroSubtitle": "Integrate appointment scheduling, customer management, and more into your applications with our powerful API and developer tools.",
    "viewDocs": "View Documentation",
    "getApiKeys": "Get API Keys",
    "featuresTitle": "Built for Developers",
    "featuresSubtitle": "Everything you need to integrate Woezor into your applications.",
    "features": {
      "rest": {
        "title": "RESTful API",
        "description": "Clean, well-documented REST API for seamless integration with your existing systems."
      },
      "oauth": {
        "title": "OAuth 2.0",
        "description": "Secure authentication using industry-standard OAuth 2.0 protocol."
      },
      "json": {
        "title": "JSON Responses",
        "description": "Consistent JSON response format with comprehensive error handling."
      },
      "webhooks": {
        "title": "Webhooks",
        "description": "Real-time event notifications to keep your systems in sync."
      },
      "rateLimit": {
        "title": "Rate Limiting",
        "description": "Fair usage policies with generous rate limits for all plans."
      },
      "uptime": {
        "title": "99.9% Uptime",
        "description": "Reliable infrastructure with high availability guarantees."
      }
    },
    "codeTitle": "Simple & Intuitive",
    "codeSubtitle": "Get started in minutes with our clean API design. Create appointments, manage customers, and access analytics with just a few lines of code.",
    "steps": {
      "signup": {
        "title": "Sign up for an account",
        "description": "Create your free developer account"
      },
      "keys": {
        "title": "Get your API keys",
        "description": "Generate keys from your dashboard"
      },
      "build": {
        "title": "Start building",
        "description": "Make your first API call"
      }
    },
    "sdksTitle": "Official SDKs",
    "sdksSubtitle": "Use our official SDKs to integrate Woezor in your favorite language.",
    "sdkStatus": {
      "stable": "stable",
      "beta": "beta",
      "coming": "coming"
    },
    "ctaTitle": "Ready to Start Building?",
    "ctaSubtitle": "Create your free account and get your API keys in minutes.",
    "getStarted": "Get Started Free",
    "talkToSales": "Talk to Sales"
  }
}
